var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { isEmpty, isNil, keys } from 'lodash-es';
import '../error/sds-error.lit';
export var StrengthLevel;
(function (StrengthLevel) {
    StrengthLevel[StrengthLevel["NONE"] = 0] = "NONE";
    StrengthLevel[StrengthLevel["TOO_SHORT"] = 1] = "TOO_SHORT";
    StrengthLevel[StrengthLevel["WEAK"] = 2] = "WEAK";
    StrengthLevel[StrengthLevel["FAIR"] = 3] = "FAIR";
    StrengthLevel[StrengthLevel["GOOD"] = 4] = "GOOD";
    StrengthLevel[StrengthLevel["STRONG"] = 5] = "STRONG";
})(StrengthLevel || (StrengthLevel = {}));
/**
 * Base class for input elements.
 *
 * @fires sds.input.changed - Event is fired when change is detected.
 * @fires sds.input - Event is fired on input.
 * @fires sds.input.action - Event is fired when an action is performed.
 * @fires sds.input.cleared - Event is fired when the input is cleared.
 *
 */
let SdsInputBase = (() => {
    var _a, _SdsInputBase_showCount_accessor_storage, _SdsInputBase_maxLength_accessor_storage, _SdsInputBase_isSelect_accessor_storage, _SdsInputBase_isExpanded_accessor_storage, _SdsInputBase_value_accessor_storage, _SdsInputBase_focused_accessor_storage, _SdsInputBase_buttonFocused_accessor_storage, _SdsInputBase_disabled_accessor_storage, _SdsInputBase_hasClear_accessor_storage, _SdsInputBase_readonly_accessor_storage, _SdsInputBase_placeholder_accessor_storage, _SdsInputBase_hint_accessor_storage, _SdsInputBase_action_accessor_storage, _SdsInputBase_pagination_accessor_storage, _SdsInputBase_strength_accessor_storage, _SdsInputBase_forgot_accessor_storage, _SdsInputBase_noResize_accessor_storage, _SdsInputBase_autoResize_accessor_storage, _SdsInputBase_withToolbar_accessor_storage, _SdsInputBase_rows_accessor_storage, _SdsInputBase_maxRows_accessor_storage, _SdsInputBase_invalid_accessor_storage, _SdsInputBase_searchable_accessor_storage, _SdsInputBase_hasSuffix_accessor_storage, _SdsInputBase_hasPrefix_accessor_storage, _SdsInputBase_rightAligned_accessor_storage, _SdsInputBase_noActions_accessor_storage, _SdsInputBase_errorMessage_accessor_storage;
    let _classSuper = LitElement;
    let _showCount_decorators;
    let _showCount_initializers = [];
    let _showCount_extraInitializers = [];
    let _maxLength_decorators;
    let _maxLength_initializers = [];
    let _maxLength_extraInitializers = [];
    let _isExpanded_decorators;
    let _isExpanded_initializers = [];
    let _isExpanded_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _focused_decorators;
    let _focused_initializers = [];
    let _focused_extraInitializers = [];
    let _buttonFocused_decorators;
    let _buttonFocused_initializers = [];
    let _buttonFocused_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _hasClear_decorators;
    let _hasClear_initializers = [];
    let _hasClear_extraInitializers = [];
    let _readonly_decorators;
    let _readonly_initializers = [];
    let _readonly_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _action_decorators;
    let _action_initializers = [];
    let _action_extraInitializers = [];
    let _pagination_decorators;
    let _pagination_initializers = [];
    let _pagination_extraInitializers = [];
    let _strength_decorators;
    let _strength_initializers = [];
    let _strength_extraInitializers = [];
    let _forgot_decorators;
    let _forgot_initializers = [];
    let _forgot_extraInitializers = [];
    let _noResize_decorators;
    let _noResize_initializers = [];
    let _noResize_extraInitializers = [];
    let _autoResize_decorators;
    let _autoResize_initializers = [];
    let _autoResize_extraInitializers = [];
    let _withToolbar_decorators;
    let _withToolbar_initializers = [];
    let _withToolbar_extraInitializers = [];
    let _rows_decorators;
    let _rows_initializers = [];
    let _rows_extraInitializers = [];
    let _maxRows_decorators;
    let _maxRows_initializers = [];
    let _maxRows_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _searchable_decorators;
    let _searchable_initializers = [];
    let _searchable_extraInitializers = [];
    let _hasSuffix_decorators;
    let _hasSuffix_initializers = [];
    let _hasSuffix_extraInitializers = [];
    let _hasPrefix_decorators;
    let _hasPrefix_initializers = [];
    let _hasPrefix_extraInitializers = [];
    let _rightAligned_decorators;
    let _rightAligned_initializers = [];
    let _rightAligned_extraInitializers = [];
    let _noActions_decorators;
    let _noActions_initializers = [];
    let _noActions_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    return _a = class SdsInputBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsInputBase_showCount_accessor_storage.set(this, __runInitializers(this, _showCount_initializers, false));
                _SdsInputBase_maxLength_accessor_storage.set(this, (__runInitializers(this, _showCount_extraInitializers), __runInitializers(this, _maxLength_initializers, 1000)));
                _SdsInputBase_isSelect_accessor_storage.set(this, (__runInitializers(this, _maxLength_extraInitializers), false));
                _SdsInputBase_isExpanded_accessor_storage.set(this, __runInitializers(this, _isExpanded_initializers, false));
                _SdsInputBase_value_accessor_storage.set(this, (__runInitializers(this, _isExpanded_extraInitializers), __runInitializers(this, _value_initializers, void 0)));
                _SdsInputBase_focused_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _focused_initializers, false)));
                _SdsInputBase_buttonFocused_accessor_storage.set(this, (__runInitializers(this, _focused_extraInitializers), __runInitializers(this, _buttonFocused_initializers, false)));
                _SdsInputBase_disabled_accessor_storage.set(this, (__runInitializers(this, _buttonFocused_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
                _SdsInputBase_hasClear_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _hasClear_initializers, true)));
                _SdsInputBase_readonly_accessor_storage.set(this, (__runInitializers(this, _hasClear_extraInitializers), __runInitializers(this, _readonly_initializers, false)));
                _SdsInputBase_placeholder_accessor_storage.set(this, (__runInitializers(this, _readonly_extraInitializers), __runInitializers(this, _placeholder_initializers, '')));
                _SdsInputBase_hint_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _hint_initializers, '')));
                _SdsInputBase_action_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _action_initializers, '')));
                _SdsInputBase_pagination_accessor_storage.set(this, (__runInitializers(this, _action_extraInitializers), __runInitializers(this, _pagination_initializers, false)));
                _SdsInputBase_strength_accessor_storage.set(this, (__runInitializers(this, _pagination_extraInitializers), __runInitializers(this, _strength_initializers, StrengthLevel.NONE)));
                _SdsInputBase_forgot_accessor_storage.set(this, (__runInitializers(this, _strength_extraInitializers), __runInitializers(this, _forgot_initializers, false)));
                _SdsInputBase_noResize_accessor_storage.set(this, (__runInitializers(this, _forgot_extraInitializers), __runInitializers(this, _noResize_initializers, false)));
                _SdsInputBase_autoResize_accessor_storage.set(this, (__runInitializers(this, _noResize_extraInitializers), __runInitializers(this, _autoResize_initializers, false)));
                _SdsInputBase_withToolbar_accessor_storage.set(this, (__runInitializers(this, _autoResize_extraInitializers), __runInitializers(this, _withToolbar_initializers, false)));
                _SdsInputBase_rows_accessor_storage.set(this, (__runInitializers(this, _withToolbar_extraInitializers), __runInitializers(this, _rows_initializers, void 0)));
                _SdsInputBase_maxRows_accessor_storage.set(this, (__runInitializers(this, _rows_extraInitializers), __runInitializers(this, _maxRows_initializers, void 0)));
                _SdsInputBase_invalid_accessor_storage.set(this, (__runInitializers(this, _maxRows_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
                _SdsInputBase_searchable_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _searchable_initializers, false)));
                _SdsInputBase_hasSuffix_accessor_storage.set(this, (__runInitializers(this, _searchable_extraInitializers), __runInitializers(this, _hasSuffix_initializers, false)));
                _SdsInputBase_hasPrefix_accessor_storage.set(this, (__runInitializers(this, _hasSuffix_extraInitializers), __runInitializers(this, _hasPrefix_initializers, false)));
                _SdsInputBase_rightAligned_accessor_storage.set(this, (__runInitializers(this, _hasPrefix_extraInitializers), __runInitializers(this, _rightAligned_initializers, void 0)));
                _SdsInputBase_noActions_accessor_storage.set(this, (__runInitializers(this, _rightAligned_extraInitializers), __runInitializers(this, _noActions_initializers, void 0)));
                _SdsInputBase_errorMessage_accessor_storage.set(this, (__runInitializers(this, _noActions_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
                this.unique = (__runInitializers(this, _errorMessage_extraInitializers), Math.random().toString(36).slice(2));
            }
            get showCount() { return __classPrivateFieldGet(this, _SdsInputBase_showCount_accessor_storage, "f"); }
            set showCount(value) { __classPrivateFieldSet(this, _SdsInputBase_showCount_accessor_storage, value, "f"); }
            get maxLength() { return __classPrivateFieldGet(this, _SdsInputBase_maxLength_accessor_storage, "f"); }
            set maxLength(value) { __classPrivateFieldSet(this, _SdsInputBase_maxLength_accessor_storage, value, "f"); }
            /**
             * True if this input is used for select/dropdown functionality.
             * Set programmatically by select input components.
             */
            get isSelect() { return __classPrivateFieldGet(this, _SdsInputBase_isSelect_accessor_storage, "f"); }
            set isSelect(value) { __classPrivateFieldSet(this, _SdsInputBase_isSelect_accessor_storage, value, "f"); }
            /**
             * True if the select menu is currently expanded/opened.
             * Set programmatically by select input components.
             */
            get isExpanded() { return __classPrivateFieldGet(this, _SdsInputBase_isExpanded_accessor_storage, "f"); }
            set isExpanded(value) { __classPrivateFieldSet(this, _SdsInputBase_isExpanded_accessor_storage, value, "f"); }
            /**
             * The value of this input.
             * @attr
             */
            get value() { return __classPrivateFieldGet(this, _SdsInputBase_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsInputBase_value_accessor_storage, value, "f"); }
            /**
             * True if component is focused.
             * @attr
             */
            get focused() { return __classPrivateFieldGet(this, _SdsInputBase_focused_accessor_storage, "f"); }
            set focused(value) { __classPrivateFieldSet(this, _SdsInputBase_focused_accessor_storage, value, "f"); }
            /**
             * True if component is action button focused.
             * @attr
             */
            get buttonFocused() { return __classPrivateFieldGet(this, _SdsInputBase_buttonFocused_accessor_storage, "f"); }
            set buttonFocused(value) { __classPrivateFieldSet(this, _SdsInputBase_buttonFocused_accessor_storage, value, "f"); }
            /**
             * True if control is disabled.
             * @attr
             */
            get disabled() { return __classPrivateFieldGet(this, _SdsInputBase_disabled_accessor_storage, "f"); }
            set disabled(value) { __classPrivateFieldSet(this, _SdsInputBase_disabled_accessor_storage, value, "f"); }
            /**
             * False if control doesn't need clear button.
             * @attr
             */
            get hasClear() { return __classPrivateFieldGet(this, _SdsInputBase_hasClear_accessor_storage, "f"); }
            set hasClear(value) { __classPrivateFieldSet(this, _SdsInputBase_hasClear_accessor_storage, value, "f"); }
            /**
             * True if control is readonly.
             * @attr
             */
            get readonly() { return __classPrivateFieldGet(this, _SdsInputBase_readonly_accessor_storage, "f"); }
            set readonly(value) { __classPrivateFieldSet(this, _SdsInputBase_readonly_accessor_storage, value, "f"); }
            /**
             * Placeholder used if this input is empty.
             * @attr
             */
            get placeholder() { return __classPrivateFieldGet(this, _SdsInputBase_placeholder_accessor_storage, "f"); }
            set placeholder(value) { __classPrivateFieldSet(this, _SdsInputBase_placeholder_accessor_storage, value, "f"); }
            /**
             * Hint for this input.
             * @attr
             */
            get hint() { return __classPrivateFieldGet(this, _SdsInputBase_hint_accessor_storage, "f"); }
            set hint(value) { __classPrivateFieldSet(this, _SdsInputBase_hint_accessor_storage, value, "f"); }
            /**
             * Action Icon for this input.
             * @attr
             */
            get action() { return __classPrivateFieldGet(this, _SdsInputBase_action_accessor_storage, "f"); }
            set action(value) { __classPrivateFieldSet(this, _SdsInputBase_action_accessor_storage, value, "f"); }
            /**
             * For Table pagination
             * @attr
             */
            get pagination() { return __classPrivateFieldGet(this, _SdsInputBase_pagination_accessor_storage, "f"); }
            set pagination(value) { __classPrivateFieldSet(this, _SdsInputBase_pagination_accessor_storage, value, "f"); }
            /**
             * Strength for this input.
             * @attr
             */
            get strength() { return __classPrivateFieldGet(this, _SdsInputBase_strength_accessor_storage, "f"); }
            set strength(value) { __classPrivateFieldSet(this, _SdsInputBase_strength_accessor_storage, value, "f"); }
            /**
             * Forgot for this input.
             * @attr
             */
            get forgot() { return __classPrivateFieldGet(this, _SdsInputBase_forgot_accessor_storage, "f"); }
            set forgot(value) { __classPrivateFieldSet(this, _SdsInputBase_forgot_accessor_storage, value, "f"); }
            get noResize() { return __classPrivateFieldGet(this, _SdsInputBase_noResize_accessor_storage, "f"); }
            set noResize(value) { __classPrivateFieldSet(this, _SdsInputBase_noResize_accessor_storage, value, "f"); }
            get autoResize() { return __classPrivateFieldGet(this, _SdsInputBase_autoResize_accessor_storage, "f"); }
            set autoResize(value) { __classPrivateFieldSet(this, _SdsInputBase_autoResize_accessor_storage, value, "f"); }
            get withToolbar() { return __classPrivateFieldGet(this, _SdsInputBase_withToolbar_accessor_storage, "f"); }
            set withToolbar(value) { __classPrivateFieldSet(this, _SdsInputBase_withToolbar_accessor_storage, value, "f"); }
            get rows() { return __classPrivateFieldGet(this, _SdsInputBase_rows_accessor_storage, "f"); }
            set rows(value) { __classPrivateFieldSet(this, _SdsInputBase_rows_accessor_storage, value, "f"); }
            get maxRows() { return __classPrivateFieldGet(this, _SdsInputBase_maxRows_accessor_storage, "f"); }
            set maxRows(value) { __classPrivateFieldSet(this, _SdsInputBase_maxRows_accessor_storage, value, "f"); }
            /**
             * True if this input is invalid.
             * @attr
             */
            get invalid() { return __classPrivateFieldGet(this, _SdsInputBase_invalid_accessor_storage, "f"); }
            set invalid(value) { __classPrivateFieldSet(this, _SdsInputBase_invalid_accessor_storage, value, "f"); }
            /**
             * True if this input is searchable.
             * @attr
             */
            get searchable() { return __classPrivateFieldGet(this, _SdsInputBase_searchable_accessor_storage, "f"); }
            set searchable(value) { __classPrivateFieldSet(this, _SdsInputBase_searchable_accessor_storage, value, "f"); }
            /**
             * True if select is used for suffix.
             * @attr
             */
            get hasSuffix() { return __classPrivateFieldGet(this, _SdsInputBase_hasSuffix_accessor_storage, "f"); }
            set hasSuffix(value) { __classPrivateFieldSet(this, _SdsInputBase_hasSuffix_accessor_storage, value, "f"); }
            /**
             * True if select is used for prefix.
             * @attr
             */
            get hasPrefix() { return __classPrivateFieldGet(this, _SdsInputBase_hasPrefix_accessor_storage, "f"); }
            set hasPrefix(value) { __classPrivateFieldSet(this, _SdsInputBase_hasPrefix_accessor_storage, value, "f"); }
            /**
             * True if this input type number right aligned.
             * @attr
             */
            get rightAligned() { return __classPrivateFieldGet(this, _SdsInputBase_rightAligned_accessor_storage, "f"); }
            set rightAligned(value) { __classPrivateFieldSet(this, _SdsInputBase_rightAligned_accessor_storage, value, "f"); }
            /**
             * True if this input type number without actions.
             * @attr
             */
            get noActions() { return __classPrivateFieldGet(this, _SdsInputBase_noActions_accessor_storage, "f"); }
            set noActions(value) { __classPrivateFieldSet(this, _SdsInputBase_noActions_accessor_storage, value, "f"); }
            /**
             * Error message.
             * @attr
             */
            get errorMessage() { return __classPrivateFieldGet(this, _SdsInputBase_errorMessage_accessor_storage, "f"); }
            set errorMessage(value) { __classPrivateFieldSet(this, _SdsInputBase_errorMessage_accessor_storage, value, "f"); }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleInput(e) {
                this.value = this.convertValue(this.getInput().value);
                this.dispatchEvent(new CustomEvent(_a.INPUT_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
                this.dispatchEvent(new CustomEvent(_a.NATIVE_INPUT_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            handleFocus() {
                this.focused = true;
            }
            handleActionFocus() {
                this.buttonFocused = true;
            }
            handleBlur() {
                this.focused = false;
            }
            handleActionBlur() {
                this.buttonFocused = false;
            }
            handleResize() { }
            showClear() {
                return !isNil(this.value) && !isEmpty(this.value) && !this.disabled && this.hasClear;
            }
            handleChanged() {
                this.dispatchEvent(new CustomEvent(_a.CHANGE_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
                this.dispatchEvent(new CustomEvent(_a.NATIVE_CHANGE_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            getClasses() {
                return classMap({
                    'sds-input': true,
                    'sds-input--focused': this.focused || this.buttonFocused,
                    'sds-input--disabled': this.disabled,
                    'sds-input--invalid': this.invalid,
                    'sds-input--searchable': this.searchable,
                    'sds-input--pagination': this.pagination,
                    'sds-input--has-action': this.action,
                    'sds-input--right-aligned': this.rightAligned,
                    'sds-input--no-resize': this.noResize,
                    'sds-input--suffix': this.hasSuffix,
                    'sds-input--prefix': this.hasPrefix,
                    'sds-input--without-clear': !this.hasClear || this.noActions,
                });
            }
            updated(changedProperties) {
                if (changedProperties.has('focused') && this.focused) {
                    this.getInput().focus();
                    this.setInputCursorToEnd();
                }
                if (changedProperties.has('value')) {
                    this.getInput().value = this.valueToString(this.value);
                }
            }
            renderInput(type) {
                return html `
            <input
                id="${this.unique}"
                class="sds-input__element"
                part="sds-input-element"
                autocomplete="off"
                ?disabled="${this.disabled}"
                placeholder="${this.placeholder}"
                value="${this.value}"
                title="${this.value}"
                type="${type}"
                ?readonly="${this.readonly}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                role="${ifDefined(this.isSelect ? 'combobox' : undefined)}"
                aria-autocomplete="${ifDefined(this.isSelect ? 'list' : undefined)}"
                aria-haspopup="${ifDefined(this.isSelect ? 'listbox' : undefined)}"
                aria-expanded="${ifDefined(this.isSelect ? (this.isExpanded ? 'true' : 'false') : undefined)}"
                @input="${(e) => this.handleInput(e)}"
                @focus="${() => this.handleFocus()}"
                @blur="${() => this.handleBlur()}"
                @change="${() => this.handleChanged()}"
                @wheel="${(event) => this.handleWheel(event)}"
                @keydown="${(event) => this.handleKeyDown(event)}"
                @keyup="${(event) => this.handleKeyUp(event)}"
            />
        `;
            }
            renderClear() {
                if (this.showClear()) {
                    return html `
                <sds-button
                    type="tertiary"
                    icon="close_circle"
                    size="md"
                    aria-label="Clear value"
                    @focus="${() => {
                        this.handleActionFocus();
                    }}"
                    @blur="${() => this.handleActionBlur()}"
                    @click="${e => this.handleClear(e)}"
                ></sds-button>
            `;
                }
            }
            renderMessages() {
                if (this.hint || this.invalid) {
                    return html `
                <div class="sds-input__messages">${this.renderHint()} ${this.renderError()}</div>
            `;
                }
            }
            renderError() {
                if (this.errorMessage && this.invalid) {
                    return html ` <sds-error message="${this.errorMessage}"></sds-error> `;
                }
            }
            renderHint() {
                if (this.hint) {
                    return html ` <div class="sds-input__hint">${this.hint}</div> `;
                }
            }
            renderAction(actionIcon) {
                if (this.action) {
                    return html `
                <sds-button
                    type="tertiary"
                    icon="${actionIcon}"
                    size="md"
                    @focus="${() => {
                        this.handleActionFocus();
                    }}"
                    @blur="${() => this.handleActionBlur()}"
                    @click="${(e) => this.dispatchAction(e)}"
                ></sds-button>
            `;
                }
            }
            renderActionContainer() {
                if (this.action || this.showClear()) {
                    return html `
                <div class="sds-input__actions" part="sds-input-actions">
                    ${this.renderClear()} ${this.renderAction(this.action)}
                </div>
            `;
                }
            }
            addEventListener(type, listener, options) {
                super.addEventListener(type, listener, options);
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleWheel(event) { }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleKeyDown(event) { }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleKeyUp(event) { }
            setInputCursorToEnd() {
                const inputElement = this.getInput();
                const valueLength = !isNil(this.value) && !isNil(this.value.length) ? this.value.length : 0;
                inputElement.selectionStart = valueLength;
                inputElement.selectionEnd = valueLength;
            }
            valueToString(value) {
                if (isNil(value)) {
                    return this.emptyValue().toString();
                }
                return value.toString();
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleClear(event) {
                this.value = this.emptyValue();
                this.dispatchEvent(new CustomEvent(_a.TEXT_CLEARED, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
                this.focused = true;
                event === null || event === void 0 ? void 0 : event.stopPropagation();
            }
            dispatchAction(e) {
                this.dispatchEvent(new CustomEvent(_a.ACTION_EVENT));
                this.focused = false;
                this.buttonFocused = false;
                e.stopPropagation();
            }
            /**
             * Programmatically click the input element.
             */
            click() {
                this.getInput().focus();
                this.handleFocus();
                const clickEvent = new MouseEvent('click', {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                    view: window,
                });
                this.dispatchEvent(clickEvent);
            }
            /**
             * Programmatically focus the input element.
             */
            focus() {
                this.getInput().focus();
                this.handleFocus();
            }
            /**
             * Programmatically blur the input element.
             */
            blur() {
                this.getInput().blur();
                this.handleBlur();
            }
        },
        _SdsInputBase_showCount_accessor_storage = new WeakMap(),
        _SdsInputBase_maxLength_accessor_storage = new WeakMap(),
        _SdsInputBase_isSelect_accessor_storage = new WeakMap(),
        _SdsInputBase_isExpanded_accessor_storage = new WeakMap(),
        _SdsInputBase_value_accessor_storage = new WeakMap(),
        _SdsInputBase_focused_accessor_storage = new WeakMap(),
        _SdsInputBase_buttonFocused_accessor_storage = new WeakMap(),
        _SdsInputBase_disabled_accessor_storage = new WeakMap(),
        _SdsInputBase_hasClear_accessor_storage = new WeakMap(),
        _SdsInputBase_readonly_accessor_storage = new WeakMap(),
        _SdsInputBase_placeholder_accessor_storage = new WeakMap(),
        _SdsInputBase_hint_accessor_storage = new WeakMap(),
        _SdsInputBase_action_accessor_storage = new WeakMap(),
        _SdsInputBase_pagination_accessor_storage = new WeakMap(),
        _SdsInputBase_strength_accessor_storage = new WeakMap(),
        _SdsInputBase_forgot_accessor_storage = new WeakMap(),
        _SdsInputBase_noResize_accessor_storage = new WeakMap(),
        _SdsInputBase_autoResize_accessor_storage = new WeakMap(),
        _SdsInputBase_withToolbar_accessor_storage = new WeakMap(),
        _SdsInputBase_rows_accessor_storage = new WeakMap(),
        _SdsInputBase_maxRows_accessor_storage = new WeakMap(),
        _SdsInputBase_invalid_accessor_storage = new WeakMap(),
        _SdsInputBase_searchable_accessor_storage = new WeakMap(),
        _SdsInputBase_hasSuffix_accessor_storage = new WeakMap(),
        _SdsInputBase_hasPrefix_accessor_storage = new WeakMap(),
        _SdsInputBase_rightAligned_accessor_storage = new WeakMap(),
        _SdsInputBase_noActions_accessor_storage = new WeakMap(),
        _SdsInputBase_errorMessage_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _showCount_decorators = [property({ attribute: 'show-count', type: Boolean })];
            _maxLength_decorators = [property({ attribute: 'maxlength', type: Number })];
            _isExpanded_decorators = [property({ type: Boolean })];
            _value_decorators = [property({ type: String || Number, reflect: true })];
            _focused_decorators = [property({ type: Boolean, reflect: true })];
            _buttonFocused_decorators = [property({ type: Boolean })];
            _disabled_decorators = [property({ type: Boolean })];
            _hasClear_decorators = [property({
                    type: Boolean,
                    attribute: 'has-clear',
                    reflect: true,
                    converter: (value) => value !== 'false',
                })];
            _readonly_decorators = [property({ type: Boolean })];
            _placeholder_decorators = [property({ type: String })];
            _hint_decorators = [property({ type: String })];
            _action_decorators = [property({ type: String })];
            _pagination_decorators = [property({ type: Boolean })];
            _strength_decorators = [property({
                    converter: value => {
                        const foundKey = keys(StrengthLevel).find(key => StrengthLevel[key] == value);
                        return isNil(foundKey)
                            ? StrengthLevel.NONE
                            : StrengthLevel[foundKey];
                    },
                })];
            _forgot_decorators = [property({ type: Boolean })];
            _noResize_decorators = [property({ attribute: 'no-resize', type: Boolean })];
            _autoResize_decorators = [property({ type: Boolean, attribute: 'auto-resize' })];
            _withToolbar_decorators = [property({ type: Boolean, attribute: 'with-toolbar' })];
            _rows_decorators = [property({ type: Number, reflect: true })];
            _maxRows_decorators = [property({ type: Number, attribute: 'max-rows', reflect: true })];
            _invalid_decorators = [property({ type: Boolean })];
            _searchable_decorators = [property({ type: Boolean })];
            _hasSuffix_decorators = [property({ attribute: 'suffix', type: Boolean })];
            _hasPrefix_decorators = [property({ attribute: 'prefix', type: Boolean })];
            _rightAligned_decorators = [property({ type: Boolean, attribute: 'right-aligned' })];
            _noActions_decorators = [property({ type: Boolean, attribute: 'no-actions' })];
            _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
            __esDecorate(_a, null, _showCount_decorators, { kind: "accessor", name: "showCount", static: false, private: false, access: { has: obj => "showCount" in obj, get: obj => obj.showCount, set: (obj, value) => { obj.showCount = value; } }, metadata: _metadata }, _showCount_initializers, _showCount_extraInitializers);
            __esDecorate(_a, null, _maxLength_decorators, { kind: "accessor", name: "maxLength", static: false, private: false, access: { has: obj => "maxLength" in obj, get: obj => obj.maxLength, set: (obj, value) => { obj.maxLength = value; } }, metadata: _metadata }, _maxLength_initializers, _maxLength_extraInitializers);
            __esDecorate(_a, null, _isExpanded_decorators, { kind: "accessor", name: "isExpanded", static: false, private: false, access: { has: obj => "isExpanded" in obj, get: obj => obj.isExpanded, set: (obj, value) => { obj.isExpanded = value; } }, metadata: _metadata }, _isExpanded_initializers, _isExpanded_extraInitializers);
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _focused_decorators, { kind: "accessor", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, get: obj => obj.focused, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, _focused_initializers, _focused_extraInitializers);
            __esDecorate(_a, null, _buttonFocused_decorators, { kind: "accessor", name: "buttonFocused", static: false, private: false, access: { has: obj => "buttonFocused" in obj, get: obj => obj.buttonFocused, set: (obj, value) => { obj.buttonFocused = value; } }, metadata: _metadata }, _buttonFocused_initializers, _buttonFocused_extraInitializers);
            __esDecorate(_a, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
            __esDecorate(_a, null, _hasClear_decorators, { kind: "accessor", name: "hasClear", static: false, private: false, access: { has: obj => "hasClear" in obj, get: obj => obj.hasClear, set: (obj, value) => { obj.hasClear = value; } }, metadata: _metadata }, _hasClear_initializers, _hasClear_extraInitializers);
            __esDecorate(_a, null, _readonly_decorators, { kind: "accessor", name: "readonly", static: false, private: false, access: { has: obj => "readonly" in obj, get: obj => obj.readonly, set: (obj, value) => { obj.readonly = value; } }, metadata: _metadata }, _readonly_initializers, _readonly_extraInitializers);
            __esDecorate(_a, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
            __esDecorate(_a, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
            __esDecorate(_a, null, _action_decorators, { kind: "accessor", name: "action", static: false, private: false, access: { has: obj => "action" in obj, get: obj => obj.action, set: (obj, value) => { obj.action = value; } }, metadata: _metadata }, _action_initializers, _action_extraInitializers);
            __esDecorate(_a, null, _pagination_decorators, { kind: "accessor", name: "pagination", static: false, private: false, access: { has: obj => "pagination" in obj, get: obj => obj.pagination, set: (obj, value) => { obj.pagination = value; } }, metadata: _metadata }, _pagination_initializers, _pagination_extraInitializers);
            __esDecorate(_a, null, _strength_decorators, { kind: "accessor", name: "strength", static: false, private: false, access: { has: obj => "strength" in obj, get: obj => obj.strength, set: (obj, value) => { obj.strength = value; } }, metadata: _metadata }, _strength_initializers, _strength_extraInitializers);
            __esDecorate(_a, null, _forgot_decorators, { kind: "accessor", name: "forgot", static: false, private: false, access: { has: obj => "forgot" in obj, get: obj => obj.forgot, set: (obj, value) => { obj.forgot = value; } }, metadata: _metadata }, _forgot_initializers, _forgot_extraInitializers);
            __esDecorate(_a, null, _noResize_decorators, { kind: "accessor", name: "noResize", static: false, private: false, access: { has: obj => "noResize" in obj, get: obj => obj.noResize, set: (obj, value) => { obj.noResize = value; } }, metadata: _metadata }, _noResize_initializers, _noResize_extraInitializers);
            __esDecorate(_a, null, _autoResize_decorators, { kind: "accessor", name: "autoResize", static: false, private: false, access: { has: obj => "autoResize" in obj, get: obj => obj.autoResize, set: (obj, value) => { obj.autoResize = value; } }, metadata: _metadata }, _autoResize_initializers, _autoResize_extraInitializers);
            __esDecorate(_a, null, _withToolbar_decorators, { kind: "accessor", name: "withToolbar", static: false, private: false, access: { has: obj => "withToolbar" in obj, get: obj => obj.withToolbar, set: (obj, value) => { obj.withToolbar = value; } }, metadata: _metadata }, _withToolbar_initializers, _withToolbar_extraInitializers);
            __esDecorate(_a, null, _rows_decorators, { kind: "accessor", name: "rows", static: false, private: false, access: { has: obj => "rows" in obj, get: obj => obj.rows, set: (obj, value) => { obj.rows = value; } }, metadata: _metadata }, _rows_initializers, _rows_extraInitializers);
            __esDecorate(_a, null, _maxRows_decorators, { kind: "accessor", name: "maxRows", static: false, private: false, access: { has: obj => "maxRows" in obj, get: obj => obj.maxRows, set: (obj, value) => { obj.maxRows = value; } }, metadata: _metadata }, _maxRows_initializers, _maxRows_extraInitializers);
            __esDecorate(_a, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
            __esDecorate(_a, null, _searchable_decorators, { kind: "accessor", name: "searchable", static: false, private: false, access: { has: obj => "searchable" in obj, get: obj => obj.searchable, set: (obj, value) => { obj.searchable = value; } }, metadata: _metadata }, _searchable_initializers, _searchable_extraInitializers);
            __esDecorate(_a, null, _hasSuffix_decorators, { kind: "accessor", name: "hasSuffix", static: false, private: false, access: { has: obj => "hasSuffix" in obj, get: obj => obj.hasSuffix, set: (obj, value) => { obj.hasSuffix = value; } }, metadata: _metadata }, _hasSuffix_initializers, _hasSuffix_extraInitializers);
            __esDecorate(_a, null, _hasPrefix_decorators, { kind: "accessor", name: "hasPrefix", static: false, private: false, access: { has: obj => "hasPrefix" in obj, get: obj => obj.hasPrefix, set: (obj, value) => { obj.hasPrefix = value; } }, metadata: _metadata }, _hasPrefix_initializers, _hasPrefix_extraInitializers);
            __esDecorate(_a, null, _rightAligned_decorators, { kind: "accessor", name: "rightAligned", static: false, private: false, access: { has: obj => "rightAligned" in obj, get: obj => obj.rightAligned, set: (obj, value) => { obj.rightAligned = value; } }, metadata: _metadata }, _rightAligned_initializers, _rightAligned_extraInitializers);
            __esDecorate(_a, null, _noActions_decorators, { kind: "accessor", name: "noActions", static: false, private: false, access: { has: obj => "noActions" in obj, get: obj => obj.noActions, set: (obj, value) => { obj.noActions = value; } }, metadata: _metadata }, _noActions_initializers, _noActions_extraInitializers);
            __esDecorate(_a, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.CHANGE_EVENT = 'sds.input.changed',
        _a.INPUT_EVENT = 'sds.input',
        _a.ACTION_EVENT = 'sds.input.action',
        _a.TEXT_CLEARED = 'sds.input.cleared',
        _a.NATIVE_INPUT_EVENT = 'input',
        _a.NATIVE_CHANGE_EVENT = 'change',
        _a;
})();
export { SdsInputBase };
